export function renderPanelGridlines(parentElem, tickValues, scale, panelLayout, xPadding) {

	const gridlines = parentElem.append('g')
		.attr('class', 'hw_panel_graph_y_gridlines');

	// Offset the y coordinates by half a pixel - D3 offsets axis ticks by the same amount.
	// Skip the minimum tick value, the baseline will be drawn over the top of it anyway.
	gridlines.selectAll('line')
		.data(tickValues.slice(1))
		.enter()
		.append('line')
		.attr('x1', panelLayout.x - xPadding)
		.attr('x2', panelLayout.x + panelLayout.width + xPadding)
		.attr('y1', d => scale(d) + 0.5)
		.attr('y2', d => scale(d) + 0.5);

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-panel-gridlines.js